import { APP_CONSTANTS } from "../../core/config/appConstants";
import Container from "../../shared/components/Container/Container";
import useTitle from "../../core/hooks/useTitle";

const AlreadyDeclined = () => {
	useTitle("Bereits abgelehnt");
	const buttons = [
		{
			label: "Zu Telekom.de",
			variant: "primary",
			onClick: () =>
				(window.location.href =
					APP_CONSTANTS.LINK.TELEKOM),
			size: "small",
			tabIndex: 2,
			ariaLabel: "Link zu Telekom.de"
		}
	];
	const icons = [
		{
			name: "error-type-standard",
			size: 64,
			color: "var(--color-error)"
		}
	];

	return (
		<Container
			title="Bereits widersprochen"
			description={
				<>
					Die E-Mail-Adresse kann nicht bestätigt
					werden, da Sie der Bestätigung bereits
					widersprochen haben. Ihre Kontaktdaten
					können Sie im{" "}
					<a
						className={"link"}
						href={
							APP_CONSTANTS.LINK
								.KUNDENCENTER
						}
						tabIndex={1}
					>
						Kundencenter
					</a>{" "}
					jederzeit einsehen und ändern.
				</>
			}
			buttons={buttons}
			icon={icons[0]}
		></Container>
	);
};

export default AlreadyDeclined;
